import * as React from "react";
import PrivacyModal from "./privacy_modal";
import TermsModal from "../../pages/signup/terms_modal";
import HowItWorksModal from "./how_it_works_modal";
import AboutUsModal from "./about_us_modal";

const linksRow1 = [
  { name: "Rent drones", href: "#" },
  { name: "Terms & Conditions", href: "#" },
  { name: "Privacy Policy", href: "#", isModal: true },
];

const linksRow2 = [
  { name: "How it works", href: "#" },
  { name: "About us", href: "#" },
];

const contactInfo = {
  email: "contact@droneden.ro",
  phone: "+40749148608",
};

const NavigationLinks: React.FC = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = React.useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = React.useState(false);
  const [isHowItWorksModalOpen, setIsHowItWorksModalOpen] = React.useState(false);
  const [isAboutUsModalOpen, setIsAboutUsModalOpen] = React.useState(false);

  const handleLinkClick = (link: { name: string; href: string; isModal?: boolean }) => {
    if (link.name === "Privacy Policy") {
      setIsPrivacyModalOpen(true);
    } else if (link.name === "Terms & Conditions") {
      setIsTermsModalOpen(true);
    } else if (link.name === "How it works" || link.name === "How It Works") {
      setIsHowItWorksModalOpen(true);
    } else if (link.name === "About us" || link.name === "About Us") {
      setIsAboutUsModalOpen(true);
    } else {
      // Handle other links normally (placeholder for now)
      // Could be extended for other links, etc.
    }
  };

  return (
    <>
      <nav className="max-w-screen-lg mx-auto grid grid-cols-1 gap-4 sm:grid-cols-3">
        {/* Primul rând */}
        <div className="flex flex-col space-y-2 text-center sm:text-left">
          {linksRow1.map((link) => (
            <button
              key={link.name}
              onClick={() => handleLinkClick(link)}
              className="hover:underline text-left"
            >
              {link.name}
            </button>
          ))}
        </div>

        {/* Al doilea rând */}
        <div className="flex flex-col space-y-2 text-center sm:text-left">
          {linksRow2.map((link) => (
            <button
              key={link.name}
              className="hover:underline text-left"
              onClick={() => handleLinkClick(link)}
            >
              {link.name}
            </button>
          ))}
        </div>

        {/* Secțiunea de contact */}
        <div className="flex flex-col space-y-2 text-center sm:text-left">
          <span className="font-bold">Contact: </span>
          <a href={`mailto:${contactInfo.email}`} className="hover:underline">
            {contactInfo.email}
          </a>
          <span>Phone: {contactInfo.phone}</span>
        </div>
      </nav>

      <HowItWorksModal
        isOpen={isHowItWorksModalOpen}
        onClose={() => setIsHowItWorksModalOpen(false)}
      />
      <AboutUsModal
        isOpen={isAboutUsModalOpen}
        onClose={() => setIsAboutUsModalOpen(false)}
      />

      <PrivacyModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
      />

      <TermsModal
        isOpen={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
      />
    </>
  );
};

export default NavigationLinks;
